import React from 'react';

import MainRoute from './Router/Route';

function App() {
  return <MainRoute />;
}

export default App;
